import { createContext } from "react";

const FernieHomeSlotContext = createContext<(slot: HTMLElement | null) => void>(() => {});

export default FernieHomeSlotContext;
